import { useEffect } from 'react';

import { useStore } from 'react-redux';

import { createRateComparisonMetadata } from './create-rate-comparison-metadata';

export const useAlternativeRatesInsuranceRecommendation = ({
  fulfillmentPlanId,
  compareRates,
  setShouldShowComparison,
  alternativeRatesRecommendation,
}) => {
  const { getState } = useStore();

  useEffect(() => {
    if (!alternativeRatesRecommendation?.insurance) {
      setShouldShowComparison(false);
      return;
    }

    compareRates({
      userRatesTotalCost: alternativeRatesRecommendation?.userRatesTotalCost,
      comparedRatesTotalCost: alternativeRatesRecommendation?.insurance.totalCost,
      comparedInsuranceProviderId: alternativeRatesRecommendation?.insurance.insuranceProviderId,
      metadata: createRateComparisonMetadata(getState(), fulfillmentPlanId),
    });
  }, [
    alternativeRatesRecommendation?.insurance,
    alternativeRatesRecommendation?.userRatesTotalCost,
    compareRates,
    fulfillmentPlanId,
    getState,
    setShouldShowComparison,
  ]);
};
